// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"297":"656002d3","323":"5c9620a1","324":"ddf045d3","453":"9e5ebab4","527":"1155f7d5","580":"f4e0fc5f","592":"5adcbf84","807":"976e62c3","939":"3fd0e8ec"}[chunkId] + ".chunk.js";
};